import React from "react";

export type StatusChipTone = "accent" | "muted" | "warning";

const TONE_CLASS: Record<StatusChipTone, string> = {
  accent: "text-accent bg-accent-15",
  warning: "text-warning bg-warning-15",
  muted: "text-fg-muted bg-bg-subtle",
};

export const StatusChip = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement> & { tone?: StatusChipTone }
>(({ tone = "muted", className = "", children, ...rest }, ref) => (
  <span
    ref={ref}
    className={`shrink-0 text-[10px] font-mono cursor-default px-1 py-px rounded-app ${TONE_CLASS[tone]} ${className}`}
    {...rest}
  >
    {children}
  </span>
));
StatusChip.displayName = "StatusChip";
